<div class="w-[325px] font-inter">
  @if ({ isAmendmentView: ref.data?.modalView === 'amendment' }; as vars) {
    <div class="flex flex-col">
      <div>
        <aux-input
          #protocolVersion
          label="Protocol Name"
          validators="required"
          [formControl]="protocolVersionFc"
          [placeholder]="vars.isAmendmentView ? 'Amendment Name/Version' : 'Protocol Version Name'"
          [showRequiredAsterisk]="true"
          auxTrimInput
        />
      </div>

      @if (ref.data?.protocolVersionOptions && vars.isAmendmentView) {
        <div class="mt-4">
          <div
            class="mb-1 text-xs"
            [ngClass]="{ 'text-aux-gray-dark': protocolVersionFc.invalid }"
            [auxTooltip]="
              'When copying a Protocol Version, Site Invoiceables from its latest Site Budget Version will also be copied.'
            "
          >
            Copy From (optional)
          </div>
          <ng-select
            placeholder="Select version"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            [searchable]="false"
            [formControl]="copyFromVersionFc"
            [appendTo]="'body'"
            [items]="ref.data!.protocolVersionOptions"
          />
        </div>
      }

      <div class="mt-4">
        <aux-input
          label="Protocol Version Effective Date"
          [formControl]="effectiveDateFc"
          placeholder="YYYY-MM-DD"
          [type]="'date'"
        />
      </div>

      <aux-file-manager
        #fileManager
        class="mt-4 h-28 bg-aux-gray-light"
        [fetchFilesOnInit]="ref.data?.modalView === 'edit'"
        [pathFn]="pathFn"
        [eager]="false"
        [metadata]="metadata"
        [showSuccessOnUpload]="true"
      >
        <div class="flex items-center justify-center text-aux-gray-dark-100">
          <aux-icon name="Upload" />
          <div class="ml-3">
            <p class="text-lg">
              Drag & Drop Documents Here or
              <span class="aux-link">Browse</span>
            </p>
          </div>
        </div>
      </aux-file-manager>
      @if (fileManager) {
        <aux-file-manager-uploaded-files [fileManager]="fileManager" />
      }
    </div>
  }
</div>
